import { render, staticRenderFns } from "./distrustOrder.vue?vue&type=template&id=473cec00&scoped=true&"
import script from "./distrustOrder.vue?vue&type=script&lang=js&"
export * from "./distrustOrder.vue?vue&type=script&lang=js&"
import style0 from "./distrustOrder.vue?vue&type=style&index=0&id=473cec00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473cec00",
  null
  
)

export default component.exports